import { ResourceProps } from "react-admin";
import { AffiliateUsersList } from "./components/affiliate-users-list";
import { AffiliateShow } from "./components";

export const affiliateUsersResource: Omit<ResourceProps, "name"> = {
  list: AffiliateUsersList,
  show: AffiliateShow,
};
